export const KMCC_PAGE_IDENTIFIER = 'kmcc-page';
export const KMCC_CONTENT_URL_ITEM_IDENTIFIER = 'kmcc-modal-content-url';



// WEBPACK FOOTER //
// ./vendor/kunstmaan/cookie-bundle/Resources/ui/js/config/page.config.js